import zhCN from './i18n-zh-CN';
import enUS from './i18n-en-US';

export default {
  'zh-CN': zhCN,
  'en-US': enUS
};

export const I18nConstant = {
  CN: 'cn',
  EN: 'en'
};



// WEBPACK FOOTER //
// ./src/lib/i18n.js